<template>
    <div class="section">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
        <div class="columns is-multiline">
            <div v-for="item in shipments" :key="item.id" class="column is-half">
               <div class="card">
                   <div class="card-content">
                        <b-field>
                            <a
                            class="has-text-danger"
                            @click="deleteMethod(item.id)">
                                <b-icon icon="trash"></b-icon>
                                Delete
                            </a>
                        </b-field>
                        <b-field label="Tipo">
                            <b-select 
                            v-model="item.method"
                            expanded
                            @input="updateShipment(item)">
                                <option value="delivery">Envio a domicilio</option>
                                <option value="retiro">Retiro en local</option>
                            </b-select>
                        </b-field>

                        <b-field label="Costo por Kg">
                            <b-numberinput
                            v-model="item.kgCost"
                            min="0"
                            step="0.01"
                            :controls="false"
                            @input="updateShipment(item)">
                            </b-numberinput>
                        </b-field>
                        <b-field label="Costo fijo">
                            <b-numberinput
                            v-model="item.fixedCost"
                            min="0"
                            step="0.01"
                            :controls="false"
                            @input="updateShipment(item)">
                            </b-numberinput>
                        </b-field>
                        <b-field label="Gratis para envios mayores a ">
                            <b-numberinput
                            v-model="item.freeFrom"
                            min="0"
                            step="0.01"
                            :controls="false"
                            @input="updateShipment(item)">
                            </b-numberinput>
                        </b-field>
                        <b-field label="Titulo">
                            <b-input 
                            v-model="item.title"
                            maxlength="80"
                            @input="updateShipment(item)"
                            > 
                            </b-input>
                        </b-field>
                        <b-field label="Detalles">
                            <b-input
                            v-model="item.details"
                            type="textarea"
                            @input="updateShipment(item)">
                            </b-input>
                        </b-field>
                   </div>
                   
               </div>
            </div>
        </div>

        <div class="columns">
            <div class="column is-full has-text-centered">
                <b-button
                type="is-primary"
                rounded
                @click="createModal=true">
                    <b-icon icon="plus" size="is-small"></b-icon>
                    Agregar metodo de envio
                </b-button>
            </div>
        </div>

        <b-modal :active.sync="createModal" scroll="keep">
            <div class="modal-card" style="width: auto">
                
                <div class="modal-card-body">
                    <div class="columns is-multiline">
                        <div class="column is-two-thirds">
                            <b-field label="Tipo">
                                <b-select 
                                v-model="newShipment.method">
                                    <option value="delivery">Envio a domicilio</option>
                                    <option value="retiro">Retiro en local</option>
                                </b-select>
                            </b-field>
                            <b-field label="Costo por Kg">
                                <b-numberinput
                                v-model="newShipment.kgCost"
                                min="0"
                                :controls="false"
                                step="0.01">
                                </b-numberinput>
                            </b-field>
                            <b-field label="Costo fijo">
                                <b-numberinput
                                v-model="newShipment.fixedCost"
                                min="0"
                                :controls="false"
                                step="0.01">
                                </b-numberinput>
                            </b-field>
                            <b-field label="gratis para envios mayores a ">
                            <b-numberinput
                                v-model="newShipment.freeFrom"
                                min="0"
                                step="0.01"
                                :controls="false"
                                @input="updateShipment(item)">
                                </b-numberinput>
                            </b-field>
                            <b-field label="Titulo">
                                <b-input 
                                v-model="newShipment.title"
                                maxlength="80"> 
                                </b-input>
                            </b-field>
                            <b-field label="Detalles">
                                <b-input
                                v-model="newShipment.details"
                                type="textarea">
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-full has-text-centered">
                            <b-button
                            type="is-primary"
                            rounded
                            :loading="createLoad"
                            @click="createMethod">
                            <b-icon icon="save" size="is-small"></b-icon>
                            Crear metodo de envio.
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { getHandler, patchHandler, postHandler, debounce, deleteHandler } from '../../../../services/http'
export default {
    props:{
        shipmentCreateUrl:{
            type:String,
            default:""
        },
        shipmentListUrl:{
            type:String,
            default:""
        },
        shipmentDetailUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            shipments:[],
            loading:false,
            newShipment:{},
            createModal:false,
            createLoad:false
        }
    },
    methods:{
        async fetchMethods(){
            this.loading = true
            var res = await getHandler(this.shipmentListUrl, {error:false, success:false})
            this.loading = false
            this.shipments = res
        },
        updateShipment: debounce(
            async function(item){
                var msgS={
                    resource:'notify',
                    text:'Metodo de envio actualizado'
                }
                var msgE={
                    resource:'notify',
                    text:'No se pudo actualizar el metodo de envio'
                }
                var url = this.shipmentDetailUrl.replace("0000", item.id)
                var res = await patchHandler(url, item, {error:msgE, success:msgS})
                this.fetchMethods()
            },
            1200
        ),
        async createMethod(){
            this.createLoad = true
            var msgS={
                resource:'notify',
                text:'Metodo de envio creado con exito'
            }
            var msgE={
                resource:'notify',
                text:'No se pudo crear el metodo de envio'
            }
            var res = await postHandler(this.shipmentCreateUrl, this.newShipment, {error:msgE, success:msgS})
            this.createLoad = false
            this.newShipment = {}
            this.createModal = false
            this.fetchMethods()
        },
        async deleteMethod(id){
            var msgS={
                resource:'notify',
                text:'Metodo de envio eliminado '
            }
            var msgE={
                resource:'notify',
                text:'No se pudo eliminar el metodo de envio'
            }
            let url = this.shipmentDetailUrl.replace("0000", id)
            let res = await deleteHandler(url, {error:msgE, success:msgS})
            this.fetchMethods()
        }
    },
    created(){
        this.fetchMethods()
    }
}
</script>